module.exports = __webpack_public_path__ + "img/maldives.a2b52a71.svg";